import Immutable from "immutable";
import { camelCaseToSnakeCase } from "./strings";

/**
 * @param {Object|*} object
 * @returns {Object|*}
 */
export function snakeCaseKeys(object) {
  if (!object) {
    return object;
  }

  return Immutable.Map(object).mapKeys(camelCaseToSnakeCase).toObject();
}
